import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var FileLock03 = function FileLock03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M14 2H8.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.2798 4 5.1198 4 6.8v10.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C6.2798 22 7.1198 22 8.8 22h6.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.7202 20 18.8802 20 17.2V8m-6-6 6 6m-6-6v6h6m-6.25 6v-1.75c0-.9665-.7835-1.75-1.75-1.75s-1.75.7835-1.75 1.75V14m-.15 4h3.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437c.109-.2139.109-.4939.109-1.054v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C14.7401 14 14.4601 14 13.9 14h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437c-.109.2139-.109.4939-.109 1.054v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C9.26 18 9.54 18 10.1 18"
    })
  }));
};
export default FileLock03;